import styled from 'styled-components'
import { BoldText } from 'components/common/text'

export const LinearText = styled(BoldText)`
  background: ${(p) => p.theme.color.linear};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`
